import { checkRole, userTypes } from '@/constants';

const getters = {

    getTutorialOverlayState: state => state.tutorialOverlayIsShown,

    isAuthorized: state => state.AppActiveUser.isAuthorized,

    isPro: state => checkRole(userTypes[4], state.AppActiveUser.userRole),

    userInfo: state => state.AppActiveUser,
};

export default getters;
